import React from 'react';
import moment from 'moment';
import classnames from 'classnames';
import * as utils from '../date_utils';
import CalendarDay from './calendarday';

export default class CalendarWeek extends React.Component {
    constructor(props) {
        super(props);

        this.newValue = props.value;
        this.lastValue = props.value;
        this.onMonthClick = this.onMonthClick.bind(this);
    }

    shouldComponentUpdate(nextProps) {
        if (this.props.value !== nextProps.value) return true;
        if (this.lastValue && utils.isSameDay(this.lastValue, nextProps.value)) return false;

        const same = this.props.startWeek.isSame(nextProps.value, 'week');
        const same1 = this.props.startWeek.isSame(this.lastValue, 'week');
        if (same) {
            this.lastValue = this.newValue;
        } else if (same1) {
            this.lastValue = null;
        }
        return same || same1;
    }

    onMonthClick(e) {
        const target = e.target;
        if (target.dataset.value) {
            this.newValue = moment(target.dataset.value);
        }
        this.props.onMonthClick(e);
    }

    isCallbackAvailable(day) {
        for (let i = 0; i < this.props.intervals.length; i++) {
            const interval = moment(this.props.intervals[i].cmbDelayedIntervalId);
            if (utils.isSameDay(interval, day)) {
                return true;
            }
        }
        return false;
    }

    render() {
        const today = moment();
        const startWeek = this.props.startWeek.clone();
        const week = startWeek.week();
        const days = [];
        var d;
        for (d = 0; d < 7; d++) {
            const day = startWeek.clone().add(d, 'days');
            const weekday = day.isoWeekday();
            const dayclass = ['day'];
            const callbackAvailable = this.isCallbackAvailable(day);
            let selected = false;
            if (weekday === 6 || weekday === 7) {
                dayclass.push('weekend');
            }
            if (!callbackAvailable) {
                dayclass.push('disabled');
            }
            if (this.props.value && utils.isSameDay(this.props.value, day)) {
                dayclass.push('selected');
                selected = true;
            }
            if (utils.isSameDay(today, day)) {
                dayclass.push('today');
            }
            const nearestIntervals = this.props.intervals.filter((interval) =>
                utils.isSameDay(moment(interval.cmbDelayedIntervalId), day)
            );
            let nearestTime =
                nearestIntervals.length > 0 ? nearestIntervals[0].cmbDelayedIntervalId : null;
            if (nearestTime && this.props.value) {
                const currentFind = day
                    .clone()
                    .set({ hour: this.props.value.hour(), minute: this.props.value.minute() });
                let nearestDiff = Math.abs(moment(nearestTime).diff(currentFind));

                for (let i = 0; i < nearestIntervals.length; i++) {
                    const interval = moment(nearestIntervals[i].cmbDelayedIntervalId);
                    const delta = Math.abs(currentFind.diff(interval));
                    if (delta < nearestDiff) {
                        nearestTime = nearestIntervals[i].cmbDelayedIntervalId;
                        nearestDiff = delta;
                    }
                    if (delta === 0) break;
                }
            }
            const visible = utils.isSameMonth(this.props.currentWeek, day);
            days.push(
                <CalendarDay
                    key={'W' + week + 'D' + d}
                    className={classnames(dayclass)}
                    visible={visible}
                    selected={selected}
                    currentDay={day}
                    onMonthClick={this.onMonthClick}
                    nearestTime={nearestTime}
                />
            );
        }
        return (
            <tr className="week" key={'W' + week}>
                {days}
            </tr>
        );
    }
}
